module.exports = __webpack_public_path__ + "img/media (17).d98fb1d2.png";